import { useEffect, useState } from "react";
import { getAuthSnapshot, refreshAuth, subscribeAuth, type AuthState } from "./authState.js";

export {
  getAuthSnapshot,
  getCsrfToken,
  refreshAuth,
  subscribeAuth,
  type AuthState,
  type AuthUser,
} from "./authState.js";
export {
  csrfFetch,
  CsrfFetchTimeoutError,
  DEFAULT_MUTATION_TIMEOUT_MS,
  type CsrfFetchOptions,
} from "./csrfFetch.js";

export function useAuth(): AuthState {
  const [state, setState] = useState<AuthState>(getAuthSnapshot);
  useEffect(() => {
    const unsubscribe = subscribeAuth(setState);
    // Pick up anything published between the first render and subscribing.
    setState(getAuthSnapshot());
    if (getAuthSnapshot().loading) void refreshAuth();
    return unsubscribe;
  }, []);
  return state;
}
